import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "audio-recorder" }
const _hoisted_2 = {
  key: 1,
  class: "wrapper"
}
const _hoisted_3 = { class: "audio-recorder__info" }
const _hoisted_4 = { class: "time" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconMicrophoneOutline = _resolveComponent("IconMicrophoneOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconClose = _resolveComponent("IconClose")
  const _component_IconCheck = _resolveComponent("IconCheck")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$options.isRecording)
      ? (_openBlock(), _createBlock(_component_NcButton, {
          key: 0,
          title: $options.startRecordingTitle,
          "aria-label": $options.startRecordingTitle,
          "aria-description": $setup.isMediaRecorderLoading ? $options.t('spreed', 'Loading …') : undefined,
          variant: "tertiary",
          disabled: $setup.isMediaRecorderLoading,
          onClick: $options.start
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_IconMicrophoneOutline, { size: 20 })
          ]),
          _: 1
        }, 8, ["title", "aria-label", "aria-description", "disabled", "onClick"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_NcButton, {
            variant: "error",
            title: $options.abortRecordingTitle,
            "aria-label": $options.abortRecordingTitle,
            onClick: $options.abortRecording
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconClose, { size: 20 })
            ]),
            _: 1
          }, 8, ["title", "aria-label", "onClick"]),
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "recording-indicator fadeOutIn" }, null, -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString($options.parsedRecordTime), 1)
          ]),
          _createVNode(_component_NcButton, {
            variant: "success",
            title: $options.stopRecordingTitle,
            "aria-label": $options.stopRecordingTitle,
            class: _normalizeClass({ 'audio-recorder__trigger--recording': $options.isRecording }),
            onClick: $options.stop
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconCheck, { size: 20 })
            ]),
            _: 1
          }, 8, ["title", "aria-label", "class", "onClick"])
        ]))
  ]))
}